var render = function render(){var _vm=this,_c=_vm._self._c;return _c('gps-ai-panel',{attrs:{"title":_vm.title,"purpose":_vm.purpose,"run-label":_vm.runLabel,"ai":_vm.ai,"loading":_vm.loading,"running":_vm.running},on:{"run":_vm.run},scopedSlots:_vm._u([{key:"default",fn:function({ result }){return [_vm._t("default",null,{"result":result})]}}],null,true)})
}
var staticRenderFns = []

export { render, staticRenderFns }